import { stemMigration2to3, stemMigration3to4, stemMigration5to6 } from './StemMigrations'

/** Migrates the song snapshot to the latest version. */
export const migrateSongToLatest = (sn: any) => {
  if (!sn) {
    return {}
  }
  if (!sn.version || sn.version < 2) {
    sn = songMigration1to2(sn)
  }
  if (sn.version < 3) {
    sn = songMigration2to3(sn)
  }
  if (sn.version < 4) {
    sn = songMigration3to4(sn)
  }
  if (sn.version < 5) {
    sn = songMigration4to5(sn)
  }
  if (sn.version < 6) {
    sn = songMigration5to6(sn)
  }
  return {
    ...sn
  }
}

/**
 * 1 -> 2 Migration Changes:
 *  - v1 stems may be a json string or object, v2 stems are always objects.
 */
export const songMigration1to2 = (sn: any) => {
  sn.version = 2
  return sn
}
const songMigration2to3 = (sn: any) => {
  const v2stems = sn.stems
  const typedStems: any[] = []
  v2stems.map((stem) => {
    typedStems.push(stemMigration2to3(stem))
  })

  sn.stems = typedStems
  sn.version = 3

  return { ...sn }
}

const songMigration3to4 = (sn: any) => {
  const v3stems = sn.stems
  const typedStems: any[] = []
  v3stems.map((stem) => {
    typedStems.push(stemMigration3to4(stem))
  })
  sn.stems = typedStems
  sn.version = 4
  return { ...sn }
}

/** LZW compression -> Gzip compression. No change to format */
const songMigration4to5 = (sn: any) => {
  sn.version = 5
  return { ...sn }
}

/** Moves NoteRows -> NoteCollections (non-quantized notes) */
const songMigration5to6 = (sn: any) => {
  const v5stems = sn.stems
  const convertedStems: any[] = []
  v5stems.map((stem) => {
    convertedStems.push(stemMigration5to6(stem))
  })
  sn.stems = convertedStems
  sn.version = 6
  return { ...sn }
}
